import 'date-fns';
import React, { useState, useEffect } from "react";
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';


export default function MaterialUIPickers(props) {
  // The first commit of Material-UI
  const [selectedDate, setSelectedDate] = React.useState(props.selectedDate);
  
  useEffect(() => {
    setSelectedDate(props.selectedDate);
  }, [props.selectedDate]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    props.onDateChange(date)
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around" className="reminderpickerpopup">
       
        <KeyboardDatePicker
          margin="normal"
          id="date-picker-dialog"
          label=""
          format="dd/MM/yyyy"
          value={selectedDate}
          onChange={handleDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
       
      </Grid>
    </MuiPickersUtilsProvider>
  );
}
